<wiz-vgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  <wiz-hgroup width="100%">
    <wiz-image *ngIf="icon" [source]="icon" height="30px" width="30px"></wiz-image>
    <wiz-label class="titleLabel" [wizLabel]="'$.common.toast.service.error.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
    <wiz-icon class="image-purple" (click)="hide()">close</wiz-icon>
  </wiz-hgroup>

  <div #scrCmd width="100%" [innerHTML]="title" class="smallTitleLabel"></div>
  <div #scrMess width="100%" [innerHTML]="message" style="font-size: 12;"></div>
  
  <wiz-vgroup width="100%" height="100%" >
    <div style="overflow: auto; width: 100%; height: 100%">
      <div #scrStack width="100%" [innerHTML]="stack" style="font-size: 12;"></div>
    </div>
    
  </wiz-vgroup>
  

</wiz-vgroup>
